import React, { useState, useEffect, useContext } from "react";

import db from "../../../services/query";
import lbl from "../../../data/Labels.json";

import { HalfYearContext } from "../../../contexts/halfYearContext";
import { PopUpContext } from "../../../contexts/popUpContext";

import DataTable from "./SubAccountsRevenuesList";
import MainButton from "../../common/MainButton";
import MainTitle from "../../common/MainTitle";
import TableMainSearch from "../../common/MainSearch";
import MainPrintLink from "../../common/MainPrint";

const SubAccountsRevenues = (props) => {
  const [data, setData] = useState([]);
  const [query, setQuery] = useState("");

  const { halfYear } = useContext(HalfYearContext);
  const { togglePopUp, popUp } = useContext(PopUpContext);

  const { tid, aid, sid } = props.match.params;

  useEffect(() => {
    const ac = new AbortController();

    requestData({ halfYear });

    return () => ac.abort();
  }, [halfYear, popUp]);

  const requestData = async (params = new Object()) => {
    try {
      const { halfYear } = params;

      let query = `revenues/types/${tid}/accounts/${aid}/subAccounts/${sid}/revenues?halfYearId=${halfYear}`;

      await db.getAll(query).then(({ data }) => {
        setData(data);
      });
    } catch ({ response }) {
      setData(response);
    }
  };

  return (
    <div className="main-content">
      <div className="main-content-header">
        <div className="right-content">
          <MainButton title={lbl.PrevPage} type={"back"} />
          <MainTitle title={data?.summary?.title} />
        </div>
        <div className="center-content">
          <TableMainSearch setQuery={setQuery} />
        </div>
        <div className="left-content">
          <MainButton
            title={lbl.AddRevenue}
            handleClick={() => togglePopUp({ form: "revenue-form", sid })}
            type={"add"}
          />
        </div>
      </div>
      <div className="main-content-body">
        <DataTable data={data} {...props} query={query}
                           params={{type: tid, account: aid, subAccount: sid, halfYear: halfYear }}
        />
      </div>
    </div>
  );
};

export default SubAccountsRevenues;
